const telefono = '34625675911'
const mensajeWhatsapp = 'Hola, Dojo Cabanyal'

/**
 * Devuelve el enlace de WhatsApp con el mensaje codificado.
 * @param {string} mensaje
 * @param {string} telefonoDestino
 * @returns {string}
 */
export const getWhatsappLink = (mensaje = mensajeWhatsapp, telefonoDestino = telefono) => {
	return `https://wa.me/${telefonoDestino}?text=${encodeURIComponent(mensaje)}`
}

export { telefono, mensajeWhatsapp }